import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-banner-img-modal',
	templateUrl: './banner-img-modal.component.html',
	styleUrls: ['./banner-img-modal.component.scss'],
})
export class BannerImgModalComponent implements OnInit {
	public defaultImage = true;
	constructor(private modalCtrl: ModalController) {}

	ngOnInit() {}
	static async show(modalCtrl: ModalController, defaultImage: boolean = true): Promise<boolean> {
		const modal = await modalCtrl.create({
			cssClass: defaultImage ? 'short-info-modal auto-height' : 'custom-height',
			component: BannerImgModalComponent,
			componentProps: {
				defaultImage: defaultImage,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}
	close() {
		this.modalCtrl.dismiss();
	}
	login() {
		this.modalCtrl.dismiss(true);
	}
}
